export const buyingGuide = {
  // -----
  bguide01: {
    title: "Mành Cuốn",
    description: [
      "Mành Cuốn rất linh hoạt, phù hợp với ngân sách của mỗi người và hợp thời trang. Với các loại vải chuyên dụng, bao gồm loại cản sáng và chống ẩm, Mành Cuốn là sự lựa chọn lý tưởng cho phòng bếp, phòng tắm và phòng ngủ.",
      "Đối với cửa sổ nhựa uPVC, Mành Cuốn có thể được lắp đặt vừa khít với khung cửa mà không cần phải khoan. Để việc điều khiển trở nên dễ dàng hơn, Mành Cuốn cũng có thể được lắp đặt động cơ.",
    ],
    content: [
      "Các kiểu dáng đa dạng màu sắc, mẫu in và hoa văn hợp thời trang",
      "Chất vải cản sáng và chống ẩm",
      "Phù hợp với nhiều kích thước cửa sổ khác nhau",
      "Không cần khoan đục đối với cửa sổ nhựa uPVC",
      "Động cơ vận hành dễ dàng",
    ],
    link: "/product/blinds/roller",
  },
  bguide02: {
    title: "Mành Lá Dọc",
    description: [
      "Mành Lá Dọc được tạo thành bởi các lá vải riêng lẻ được cố định song song với nhau. Các lá dọc có thể được điều chỉnh nghiêng để đảm bảo sự riêng tư trong khi vẫn cho phép ánh sáng xuyên qua và có thể đóng lại bằng cách điều chỉnh các lá nằm ngang để chắn ánh sáng chói chang từ mặt trời. Bạn cũng có thể kéo mành sang một bên nếu muốn có một cái nhìn toàn cảnh rõ ràng hơn.",
      "Mành Lá Dọc phù hợp với cửa sổ dốc và cửa sổ cong. Chúng được làm từ nhiều loại vải với chức năng khác nhau như vải chắn sáng, chống cháy hay nhựa PVC dễ dàng lau chùi. Mành Lá Dọc là giải pháp tối ưu về chi phí cho các cửa sổ lớn như cửa kính trượt hay cửa hiên.",
    ],
    content: [
      "Các lá dọc có thể điều chỉnh nghiêng để lọc ánh sáng",
      "Sự lựa chọn tuyệt vời cho cửa sổ nghiêng và cong",
      "Tính linh hoạt và hiệu quả về chi phí cho các cửa sổ có kích thước lớn và cửa kính",
      "Các loại vải với nhiều chức năng khác nhau cho mọi căn phòng",
      "Kiểm soát sự riêng tư và ánh sáng dễ dàng",
    ],
    link: "/product/blinds/vertical",
  },
  bguide03: {
    title: "Mành Sáo Ngang",
    description: [
      "Mành Sáo Ngang kim loại gồm các thanh kim loại nằm ngang cố định song song với nhau bằng dây. Những thanh gỗ có thể được điều chỉnh nằm ngang theo chiều dọc song song với cửa sổ để cản sáng hay nghiêng để cho ánh sáng lọt vào. Khi kéo thẳng mành lên, bạn sẽ có tầm nhìn ra toàn bộ phía bên ngoài cửa sổ.",
      "Mành Sáo Ngang đa dạng về màu sách và kiểu dáng phù hợp với gu thẩm mỹ của riêng bạn. Nếu cửa nhà bạn là cửa sổ nhựa uPVC hay cửa kính trượt thì mành vẫn có thể vừa khít với khung cửa nên việc sử dụng thêm dây là không cần thiết.",
    ],
    content: [
      "Các thanh Sáo Lá đa dạng về chiều rộng để vừa với loạt kích thước cửa sổ khác nhau",
      "Thành phẩm kim loại giúp tăng cường mức độ ánh sáng",
      "Linh hoạt điều chỉnh ánh sáng và sự riêng tư",
      "Lớp hoàn thiện kim loại với vẻ sang trọng, bóng và mờ cho phong cách hiện đại",
      "Không cần khoan đối với cửa sổ nhựa uPVC",
    ],
    link: "/product/blinds/venetian",
  },
  bguide04: {
    title: "Mành Cầu Vồng",
    description: [
      "Mành Cuốn Voan và Chống nắng chống nóng mang đến giải pháp tối ưu về sự riêng tư và điều khiển ánh sáng. Về cơ bản, đây là một loại Mành Cuốn nhiều lớp với các tấm mờ và trong suốt chồng lên nhau để trông như các thanh đóng và mở. Về cái nhìn tổng thể, Mành Cầu Vồng mang lại dáng vẻ mềm mại hơn so với Mành Sáo Ngang và có lợi thế về động cơ.",
      "Mành Cuốn Voan và Chống nắng chống nóng là lựa chọn tuyệt vời cho phong cách nội thất hiện đại và các cửa sổ rộng đòi hỏi sự riêng tư, nhất là vào thời điểm ban ngày",
    ],
    content: [
      "Điều chỉnh ánh sáng linh hoạt - kết hợp các dải trong suốt và mờ trong một mành đơn",
      "Trông như Mành Cuốn nhưng lại có chức năng như Mành Sáo Ngang",
      "Có tùy chọn điều khiển bằng động cơ",
      "Lựa chọn tối ưu cho quyền riêng tư vào ban ngày và điều chỉnh ánh sách linh hoạt",
      "Giải pháp hoàn hảo cho cửa rộng lớn",
    ],
    link: "/product/blinds/zebra",
  },
  bguide05: {
    title: "Màn đục khoen",
    description: [
      "Màn đục khoen với đầu màn được đục các lỗ nhỏ được bao bằng khoen kim loại để luồn cây vào. Màn được treo sao cho tạo thành các nếp gấp sâu, đồng đều nhau từ trên xuống dưới. Loại đầu màn này rất thời thượng đối với những ngôi nhà theo phong cách hiện đại.",
    ],
    content: [
      "Phù hợp với nhiều phong cách và túi tiền",
      "Tạo ra các đường đơn giản mà thu hút trên màn",
      "Tạo cảm giác phòng to hơn",
      "Nhiều lựa chọn về màu sắc và kiểu dáng",
    ],
    link: "/product/curtains/day",
  },
  bguide06: {
    title: "Màn đầu nhún bút chì",
    description: [
      "Loại màn đầu nhún bút chì này xếp vải thành những hình bán trụ trông như một dãy các cây bút chì. Màn có chiều dài gần chạm mặt sàn. Đây là loại đầu màn cổ điển đi kèm với cây hoặc đường ray để kéo.",
    ],
    content: [
      "Tất cả các màn cửa được sản xuất theo số đo phù hợp với từng kích thước cửa và đầu màn được thiết kế với các nếp gấp bút chì",
      "Các nếp gấp bút chì sẽ được thiết kế sâu hơn phù hơn với các cửa sổ cao",
      "Màn đầu nhún bút chì có thể được treo lên cây hoặc đường ray",
      "Linh hoạt và phù hợp với mọi túi tiền",
    ],
    link: "/product/curtains/day",
  },
  bguide07: {
    title: "Màn đầu nhún xếp ly",
    description: [
      "Màn đầu nhún xếp ly xếp một lượng lớn vải lại với nhau, được xếp thành từng nhún một và khâu lại để tạo ra một thành phẩm mang tính thẩm mỹ cao với các nếp gấp thanh lịch. Bạn có thể treo loại màn này lên bằng cây hay đường ray.",
    ],
    content: [
      "Tất cả các màn cửa được sản xuất theo số đo phù hợp với từng kích thước cửa và đầu màn được thiết kế với các đầu nhún xếp ly",
      "Có thể lựa chọn đầu nhún xếp ly hai lớp hoặc ba lớp",
      "Màn đầu nhún xếp ly có thể được treo lên cây hoặc đường ray",
      "Một lựa chọn linh hoạt, đáng giá",
      "Tất cả mọi thứ sẽ được lo chu toàn cho bạn",
    ],
    link: "/product/curtains/day",
  },
  bguide08: {
    title: "Màn đầu gợn sóng",
    description: [
      "Màn đầu gợn sóng mang lại cảm giác thoải mái và thư giãn. Màn được chia thành các nếp gấp mềm mại, gợn sóng. Loại màn này được treo lên một đường ray mỏng. ",
    ],
    content: [
      "Màn đầu gợn sóng giúp nó được treo lên với những nếp gấp mềm mại đem đến cảm giác thoải mái",
      "Màn đầu gợn sóng được treo lên bằng một đường ray kín đáo được thiết kế chuyên biệt",
      "Màn đầu gợn sóng được xếp thành các nếp gấp gọn gàng nên đây sẽ là một lựa chọn tuyệt vời nếu bạn không có nhiều khoảng trống kế bên cửa sổ",
      "Một giải pháp linh hoạt, thời thượng và phù hợp với mọi túi tiền",
    ],
    link: "/product/curtains/day",
  },
  bguide09: {
    title: "Cửa chớp vừa chiều cao",
    description: [
      "Đây là kiểu dáng cửa chớp phổ biến và linh hoạt nhất của chúng tôi. Mỗi khung cửa chớp được thiết kế vừa khít với chiều cao của cửa sổ nhà bạn. Cửa chớp vừa chiều cao mang đến cho bạn một cái nhìn cổ điển và tinh tế, đảm bảo các mức độ quyền riêng tư và điều chỉnh ánh sáng. Chúng phù hợp với mọi kiểu dáng và phong cách cửa sổ đồng thời có thể dành cho cả cửa kính và cửa hiên lớn.",
      "Với cửa chớp chúng tôi cung cấp, bạn có thể chọn từ loạt các thanh ngang với chiều rộng khác nhau. Cửa sổ nhỏ và nhà theo phong cách cổ điển sẽ phù hợp hơn với cách thanh ngang mảnh trong khi cửa sổ lớn ở các căn nhà hiện đại sẽ trông đẹp mắt hơn với cách thanh ngang rộng.",
    ],
    content: [
      "Nhiều sự lựa chọn với loạt các vân gỗ, màu sơn và bao gồm cả các màu tùy chỉnh theo gu thẩm mỹ cá nhân",
      "Tùy chọn chống nước cho phòng bếp và phòng tắm",
      "Các thanh ngang ở phần trên và phần dưới có thể di chuyển cùng nhau hoặc riêng biệt",
      "Cửa chớp với các thanh ngang hoặc cửa chớp liền nguyên khối",
      "Một giải pháp linh hoạt và thời thượng phù hợp với mọi túi tiền",
    ],
    link: "/product/shutters/timber",
  },
  bguide10: {
    title: "Cửa chớp từng lớp",
    description: [
      "Cửa chớp từng dãy là một sự lựa chọn thiết thực và thời thượng để xua tan đi cái nóng với các thanh ngang ở trên và ở dưới đóng mở độc lập với nhau để kiểm soát tốt ánh sáng và sự riêng tư hơn. Dịch vụ tại nhà của chúng tôi bao gồm chuyên gia đến tận nơi đo đạc và lắp đặt giúp bạn có một thành phẩm tối ưu và dễ dàng đánh giá được giá trị của thành phẩm.",
    ],
    content: [
      "Nhiều sự lựa chọn với loạt các vân gỗ, màu sơn và bao gồm cả các màu tùy chỉnh theo gu thẩm mỹ cá nhân",
      "Tùy chọn chống nước cho phòng bếp và phòng tắm",
      "Các thanh ngang ở phần trên và phần dưới có thể di chuyển cùng nhau hoặc riêng biệt",
      "Cửa chớp với các thanh ngang hoặc cửa chớp liền nguyên khối",
      "Giảm ánh sáng chiếu vào nhưng vẫn đảm bảo đủ mức độ sáng phục vụ cho việc học tập và làm việc của bạn",
      "Phù hợp với nhu cầu riêng tư và điều chỉnh ánh sáng",
      "Hiệu quả về chi phí và phong cách tinh tế",
    ],
    link: "/product/shutters/timber",
  },
  bguide11: {
    title: "Cửa chớp liền nguyên khối",
    description: [
      "Cửa chớp liền nguyên khối là lựa chọn tinh tế và tuyệt với cho bất cứ phong cách nhà hay kiểu dáng cửa sổ nào. Đây là loại cửa phù hợp để xua tan đi cái nắng nóng của mùa hè và cách nhiệt cho ngôi nhà bạn vào mùa đông mà vẫn tôn lên phong cách ngôi nhà của bạn.",
    ],
    content: [
      "Thiết kế một bảng cửa duy nhất giúp ngăn chặn hoàn toàn ánh sáng không mong muốn vào ban ngày",
      "Thêm một lớp cách nhiệt giúp duy trì nhiệt độ bên trong",
      "Có thể được lắp đặt vào đường ray và sử dụng như một vách ngăn phòng để mang đến sự riêng tư hơn",
      "Lựa chọn cửa chớp với các thanh ngang hoặc cửa chớp liền nguyên khối",
      "Hiệu quả về chi phí và phong cách tinh tế cho mọi căn nhà",
      "Sự lựa chọn vượt trội cho cửa kính lớn như cửa hiên trượt",
      "Tạo cảm giác như một bức tưởng giả khi đóng cửa chớp lại",
    ],
    link: "/product/shutters/timber",
  },
  bguide12: {
    title: "Cửa Chớp Gấp Khúc",
    description: [
      "Đánh tan cái nóng với cửa chớp gấp khúc. Đây là lựa chọn lý tưởng cho cửa sổ lớn, trượt hay cửa hai cánh. Chúng trượt mở trên rãnh được thiết kế đặc biệt để tạo ra cơ chế trượt mượt và trơn tru. Yếu tố chất lượng ghi điểm trong dịch vụ của chúng tôi bao gồm việc chuyên gia đo đạc và lắp đặt.",
    ],
    content: [
      "Sản phẩm tuyệt vời để điều chỉnh ánh sáng và đảm bảo sự riêng tư, nhất là với cửa hai cánh và các cửa kính khác",
      "Lựa chọn chống nước cho nhà bếp và phòng tắm",
      "Lựa chọn hoàn hảo đóng vai trò như vách ngăn phòng và đem đến sự riêng tư",
      "Có thể kéo cửa về một bên giúp bạn có thể ngắm nhìn toàn cảnh từ cửa sổ",
      "Một phong cách tinh tế và tiết kiệm chi phí",
    ],
    link: "/product/shutters/timber",
  },
  bguide13: {
    title: "Cửa chớp theo khuôn",
    description: [
      "Xua tan đi cái nóng với cửa chớp theo khuôn. Đây là lựa chọn hoàn hảo cho việc nâng tầm cửa sổ hình vòm, hình tam giác, hình tròn hoặc cửa sổ nhỏ. Chúng tôi có thể thiết kế cửa chớp sao cho phù hợp và vừa khít với bất kỳ kích thước và hình  dạng cửa sổ nào với dịch vụ thiết kế theo số đo riêng của chúng tôi. Cửa chớp theo khuôn của chúng tôi đa dạng về màu sắc, từ các đường vân gỗ tự nhiên cho đến các màu sắc tùy chỉnh.",
    ],
    content: [
      "Kiểm soát ánh sáng và sự riêng tư cho các cửa sổ nhỏ hoặc có hình dạng đặc biệt",
      "Hoàn toàn có thể tùy chỉnh cho hầu hết các cửa sổ có kích thước hay hình dạng không theo tiêu chuẩn",
      "Tùy chọn chống thấm nước cho nhà bếp hoặc phòng tắm",
      "Bảo hành đầy đủ trong năm năm giúp khách hàng yên tâm hơn",
      "Một giải pháp tinh tế và tiết kiệm chi phí cho bất kỳ cửa sổ nào",
    ],
    link: "/product/shutters/timber",
  },
  bguideCurtain: {
    title: "Làm sao để chọn một bức màn hoàn hảo cho mái nhà của bạn",
    link: "/product/curtains/day",
    items: [
      {
        title: "Nghĩ về độ dày của màn",
        content:
          "Các loại đầu màn khác nhau sẽ cần các mức độ dày khác nhau. Một tấm vải mỏng có thể sẽ cần nhiều vải hơn so với chất liệu vải dày đối với độ dày cao để đạt được kiểu dáng tương tự.",
        image: "",
      },
      {
        title: "Chọn độ cao để treo màn của bạn",
        content:
          "Để tạo cảm giác căn phòng của bạn trông cao hơn thì bạn nên cố định màn của bạn cao hơn vài inch so với đỉnh của khung cửa sổ. Bạn cũng có thể xem xét xem bộ tản nhiệt có ở gần cửa sổ không vì nếu có thì chiều dài của màn có thể cần thay đổi.",
      },
      {
        title: "Chọn màn lót phù hợp",
        content:
          "Mọi màn cửa của chúng tôi được lót theo tiêu chuẩn của một thành phẩm sang trọng và đầy đủ. Lớp vải lót có thể đóng vai trò như một lớp lót cách nhiệt giúp cách nhiệt cho ngôi nhà hay như một lớp lót cản sáng để giúp ngăn chặn sáng bên ngoài chiếu vào bên trong cửa sổ.",
      },
      {
        title: "Treo cùng với màn những vật dụng che cửa sổ khác",
        content:
          "Để tăng thêm hiệu quả về thẩm mỹ hoặc công dụng thiết thực, bạn có thể xếp lớp các sản phẩm khác với màn ở cửa sổ của mình. Đặt thêm một lớp mành ở giữa màn và cửa sổ là một cách tuyệt vời để tạo cảm giác về chiều sâu bằng cách tận dụng kết cấu và hoa văn hay tăng cường hiệu quả cản sáng hoặc cách âm và nhiệt.",
      },
      {
        title: "Thêm một lớp Màn Voan mỏng, nhẹ và sáng",
        content:
          "Một lựa chọn khác là thêm một lớp voan ở giữa màn và cửa sổ. Sự kết hợp của một tấm voan mỏng với một tấm màn sẽ trông rất đẹp mắt và tăng thêm nét tinh tế cho cửa sổ.",
      },
      {
        title: "Kết thúc với các phụ kiện thời thượng",
        content:
          "Bước hoàn thiện với các phụ kiện bạn chọn cho bức màn của bạn cũng quan trọng như chất vải đối với thành phẩm ấy vậy. Đặt một lịch hẹn tại nhà với chuyên viên ở Rèm cửa Huy Hoàng  và bạn sẽ được tư vấn từ một cái nhìn của chuyên gia và hiểu hơn về thành phẩm cuối cùng.",
      },
    ],
  },
};
